import Part from '@/models/Part/Part';

export default class PartFilter {

	constructor() {
		/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.partNumber = '';
		this.partName = '';
		this.partSpecificationMultiple = '';
		this.partReferenceId = '';
		this.partReferencePartNumber = '';
		this.customerId = '';
		this.customerCode = '';
		this.isDirectDelivery = false;
		this.stockLevelCustomer = '';
		this.partClassificationId = '';
		this.partClassificationCode = '';
		this.packagingTypeId = '';
		this.packagingTypeCode = '';
		this.uomId = '';
		this.uomCode = '';
		this.uomPoId = '';
		this.uomPoCode = '';
		this.standarPackagingQty = '';
		this.vendorSubcontractId = '';
		this.vendorSubcontractCode = '';
		this.isNeedRepacking = false;
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
		this.notPartClassificationCodes = '';
		this.partCombination = '';
		/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
			/*APP_APP_FILTER_CRITERIA*/
			id: '0',
			partNumber: '0',
			partName: '0',
			partSpecificationMultiple: '0',
			partReferenceId: '0',
			partReferencePartNumber: '0',
			customerId: '0',
			customerCode: '0',
			isDirectDelivery: '0',
			stockLevelCustomer: '0',
			partClassificationId: '0',
			partClassificationCode: '0',
			packagingTypeId: '0',
			packagingTypeCode: '0',
			uomId: '0',
			uomCode: '0',
			uomPoId: '0',
			uomPoCode: '0',
			standarPackagingQty: '0',
			vendorSubcontractId: '0',
			vendorSubcontractCode: '0',
			isNeedRepacking: '0',
			isFromUpload: '0',
			isSavedToBackend: '0',
			partCombination: '0',
			/*END_APP_FILTER_CRITERIA*/
		};
	}

}